import { combine, withContext } from 'react-hooks-combine'
import { admin } from 'routes/route.map'
import { StoreContext } from 'store/context'

import MenuComponent from './component'

export default combine({
  hooks: [withContext('appConfig', StoreContext, ({ appConfig }) => appConfig)],
  transformProps: ({ className, appConfig }) => ({
    appConfig,
    className,
    items: [
      {
        title: 'Beneficiaries',
        icon: 'building',
        path: admin.beneficiaries(),
      },
      {
        title: 'Sponsors',
        icon: 'dollar-sign',
        path: admin.sponsors(),
      },
      {
        title: 'Members',
        icon: 'users',
        path: admin.members(),
      },
      {
        title: 'Tournaments',
        icon: 'trophy',
        path: admin.tournaments(),
      },
      {
        title: 'Teams',
        icon: 'users',
        path: admin.teams(),
      },
      {
        title: 'Events',
        icon: ['far', 'user'],
        path: admin.events(),
      },
      {
        title: 'Athletes',
        icon: 'dumbbell',
        path: admin.athletes(),
      },
      {
        title: 'Triggers',
        icon: 'bezier-curve',
        path: admin.triggers(),
      },
      {
        title: 'Charts',
        icon: 'star',
        path: admin.charts(),
      },
    ],
  }),
})(MenuComponent)
